<template>
  <div>
    <a-modal
      v-model:visible="visible"
      width="500px"
      title="编辑信息"
      :maskClosable="false"
      okText="提交"
      @ok="ok"
    >
      <div class="body">
        <div class="patients">
          <div
            @click="handlePatient(patient.patientProfileId)"
            class="patient"
            v-for="patient in patientProfiles"
            :key="patient.id"
            :class="{ 'patient-active': patient.isActive }"
          >
            <div class="top">
              {{ patient.patientProfileName }}
            </div>
            <div class="bottom">
              {{ genderText(patient.gender) }}
              <span v-if="patient.age !== null">{{ patient.age }} 岁</span>
            </div>
            <!-- 关系 -->
            <div class="absolute relation" :class="{ 'relation-active': patient.isActive }">
              {{ patientRelationMap[patient.relation] }}
            </div>
            <!-- 蓝色勾勾 -->
            <div v-show="patient.isActive" class="absolute check">
              <check-outlined />
            </div>
          </div>
        </div>

        <a-form class="form-container" :model="form">
          <a-form-item class="form-item" label="姓名" v-bind="validateInfos.patientName">
            <a-input :maxlength="100" class="component" v-model:value="form.patientName"></a-input>
          </a-form-item>
          <a-form-item class="form-item" label="性别" v-bind="validateInfos.patientGender">
            <a-radio-group
              class="component"
              :options="[
                { label: '女', value: 0 },
                { label: '男', value: 1 }
              ]"
              v-model:value="form.patientGender"
            />
          </a-form-item>
          <a-form-item class="form-item" label="年龄" v-bind="validateInfos.patientAge">
            <div class="component">
              <a-input-number
                id="inputNumber"
                v-model:value="form.patientAge"
                :min="0"
                :max="120"
              />
              <span class="util">岁</span>
            </div>
          </a-form-item>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, defineExpose, defineEmits, reactive, computed, nextTick } from 'vue'
import { patientGenderMap, patientRelationMap } from './config.js'
import { Form } from 'ant-design-vue'
import { useStore } from 'vuex'
import { getListBusinessPatientProfile } from '@/api/workPlace/workOrder.js'
import { CheckOutlined } from '@ant-design/icons-vue'
const store = useStore()
const info = computed(() => store.state.preMedicalRecord)

const useForm = Form.useForm
const emits = defineEmits(['ok'])
const visible = ref(false)
const patientProfiles = ref([])
const form = ref({
  patientName: '',
  patientAge: null,
  patientGender: null,
  patientProfileId: '',
  relation: null
})
const rulesRef = reactive({
  patientName: [
    {
      required: true,
      message: '请输入名称'
    }
  ],
  patientAge: [
    {
      required: true,
      message: '请输入年龄'
    }
  ],
  patientGender: [
    {
      required: true,
      message: '请选择性别'
    }
  ]
})
const { clearValidate, validate, validateInfos } = useForm(form.value, rulesRef)
const ok = () => {
  validate().then(() => {
    const genderStr = genderText.value(form.value.patientGender)
    const ans = {
      patientAge: form.value.patientAge,
      patientGender: form.value.patientGender,
      genderStr: genderStr,
      patientName: form.value.patientName,
      relation: form.value.relation,
      // patientProfileId: form.value.patientProfileId
      // 就诊人id 始终是 info.value.patientProfileId 不会因为切换变化
      patientProfileId: info.value.patientProfileId
    }
    store.commit('preMedicalRecord/UPDATE_PRE_MEDICAL_RECORD', ans)
    console.log(ans)
    // emits('ok')
    visible.value = false
  })
}
const init = () => {
  const params = {
    ucPatientId: info.value.ucPatientId,
    ucDoctorId: info.value.ucDoctorId,
    businessType: 3
  }
  // 就诊人信息
  getListBusinessPatientProfile(params)
    .then(result => {
      patientProfiles.value = result.map(m => {
        return {
          ...m,
          // 未知的情况变成 null
          gender: m.gender > 1 ? null : m.gender,
          isActive: false
        }
      })
      handlePatient(info.value.patientProfileId)
    })
    .catch(err => {})
}
// 点击就诊人
const handlePatient = patientProfileId => {
  patientProfiles.value.forEach(e => {
    e.isActive = patientProfileId === e.patientProfileId
    if (patientProfileId === e.patientProfileId) {
      form.value.patientName = e.patientProfileName
      form.value.patientGender = e.gender
      form.value.patientAge = e.age
      form.value.relation = e.relation
      form.value.patientProfileId = e.patientProfileId
    }
  })
  nextTick(() => {
    clearValidate()
  })
}
const open = () => {
  init()
  visible.value = true
}

defineExpose({
  open
})
const genderText = computed(() => {
  return function (gender) {
    const find = patientGenderMap.find(item => item.value === gender)
    return find ? find.label : '未知'
  }
})
</script>

<style lang="scss" scoped>
.body {
  // 头部就诊人信息
  padding: 0 24px;
  .patients {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 12px;
    .patient {
      width: calc(33.33% - 8px);
      border-radius: 8px;
      background: #f7f8fb;
      border: 1px solid transparent;
      margin-right: 8px;
      margin-bottom: 8px;
      padding: 10px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      .top {
        margin-bottom: 8px;
        font-weight: 500;
        font-size: 16px;
        color: #1b1b1b;
      }
      .bottom {
        color: #6f7d92;
        font-size: 12px;
      }
      .absolute {
        position: absolute;
      }
      .relation {
        top: 0;
        right: 0;
        border-radius: 8px;
        color: #999999;
        background: #eeeff2;
        padding: 1px 4px;
        font-size: 10px;
        border-radius: 0 7px 0 8px;
      }
      .relation-active {
        color: rgba(24, 144, 255, 0.8);
        background: rgba(24, 144, 255, 0.12);
      }
      .check {
        width: 17px;
        height: 17px;
        border-radius: 8px;
        background: #1890ff;
        font-size: 10px;
        right: 0;
        bottom: 0;
        color: white;
        border-radius: 8px 0 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .patient-active {
      border-color: #1890ff;
      background: #1890ff14;
    }
  }
  // 中间表单
  .form-container {
    .form-item {
      // margin-bottom: 10px;
      // display: flex;
      // align-items: center;
      .label {
        width: 50px;
      }
      .component {
        flex: 1;
        .util {
          margin-left: 8px;
        }
      }
    }
  }
}
</style>
